import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { EditButton, GreenText, LabelField } from 'components'
import { OutboundTripDetailDto, OutboundTripDetailNotesDto } from 'dtos/outboundTrips'
import { useState } from 'react'
import NotesDialog from './NotesDialog'
import { saveNotes } from 'controllers/outboundTrips/index'
import { enqueueSnackbar } from 'notistack'

interface NotesCardProps {
  notes?: OutboundTripDetailNotesDto
  outboundTripGuid?: string
  setState: (outboundTripDetail: OutboundTripDetailDto) => void
}

export default function NotesCard({ notes, outboundTripGuid, setState }: NotesCardProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)

  return (
    <>
      <NotesDialog
        initialValues={notes ?? { internalNotes: undefined, externalNotes: undefined }}
        isLoading={isSaving}
        onClose={() => setDialogOpen(false)}
        onSave={values => {
          setIsSaving(true)
          saveNotes(outboundTripGuid!, values)
            .then(res => {
              enqueueSnackbar('Notes Saved Successfully!', { variant: 'success' })
              setState({ notes: res.value })
              setDialogOpen(false)
            })
            .finally(() => setIsSaving(false))
        }}
        open={dialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h6'>
                  Notes
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <EditButton onEdit={() => setDialogOpen(true)} />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Internal Notes' value={notes?.internalNotes} />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Bill Of Lading Notes' value={notes?.externalNotes} />
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**EDIT Button:**

Clicking the EDIT button opens the Edit Notes Dialog.

**Internal Notes Label:**

Displays Internal Notes.

This Label appear only on this screen and the Outbound Trips-related To-Do Lists.

If no value has been entered for the Manufacturer Label Received, a “-” will be displayed.

**Outbound Bill of Lading Notes:**

Displays Outbound Bill Of Lading Notes.

These notes appear directly on the Outbound Bill of Lading PDF.

If no value has been entered for the Manufacturer Label Ordered, a “-” will be displayed.`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
